const padNum = (num, size = 2) => {
  return String(num).padStart(size, "0")
}

const timezone8 = (date) => {
  const timezone = 8 //目标时区时间，东八区
  const offset_GMT = date.getTimezoneOffset() // 本地时间和格林威治的时间差，单位为分钟
  const dateTime = date.getTime() // 本地时间距 1970 年 1 月 1 日午夜（GMT 时间）之间的毫秒数
  const targetDate = new Date(
    dateTime + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000
  )
  return targetDate
}

export const parseDate = (dateStr, toT8 = false) => {
  const parsed = {
    year: "0000",
    month: "00",
    date: "00",
    hour: "00",
  }
  if (!dateStr) {
    return parsed
  }
  let date = new Date(dateStr)
  if (toT8) {
    date = timezone8(date)
  }
  if (Number.isNaN(date.getDate())) {
    return parsed
  }
  parsed.year = date.getFullYear().toString()
  parsed.month = (date.getMonth() + 1).toString()
  parsed.date = date.getDate().toString()
  parsed.hour = date.getHours().toString()
  return parsed
}

export const byToday = (dateStr) => {
  const parsed = "0000"
  if (!dateStr) {
    return parsed
  }
  const date = new Date(dateStr)
  const offset = new Date() - date
  if (Number.isNaN(offset)) {
    return parsed
  }
  return Math.floor(offset / 1000 / 60 / 60 / 24).toString()
}

export const secondsToHours = (secs) => {
  const secNum = parseInt(secs, 10)
  let hours
  let minutes
  let seconds

  hours = Math.floor(secNum / 60 / 60)
  minutes = Math.floor(secNum / 60)
  if (hours <= 0) {
    if (minutes <= 0) {
      seconds = secNum
      return {
        seconds: padNum(seconds),
      }
    }
    seconds = secNum - minutes * 60
    return {
      minutes: padNum(minutes),
      seconds: padNum(seconds),
    }
  }
  seconds = secNum - minutes * 60
  minutes = minutes - hours * 60
  return {
    hours: padNum(hours),
    minutes: padNum(minutes),
  }
}
